import React from 'react'
import styled from 'styled-components';
import IconBtnYes from '../../../resources/images/icon/login/iconimg_link_yes4m.svg';
import IconLink from '../../../resources/images/icon/login/iconimg_link.svg';
import IconHspt from '../../../resources/images/icon/login/icon_hospital_link.svg'
import { _O } from '../../../modules/utils';
import { closeLayerFn } from './../../Layout';
import { setCookie } from '../../../modules/utils/cookie';

export const HsptCnntTutorial = () => {
  return (
    <div className="blacklayer-container confirm-layer-hsptcnnt">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div style={{position:"absolute", width:"90%", height:"30vh", display:"flex", top:"34px"}}>
          <div style={{width:"50%"}}></div>
          <div style={{width:"50%", borderLeft:"1px dashed #fff", borderTop:"1px dashed #fff"}}>
            <img src={IconHspt} style={{ position:"relative", top: "-22px", float: "right" }} />
          </div>
        </div>

        <div style={{position:"relative", top:"50%", transform:"translateY(-64%)"}}>
          <MsgContainer>
            <img src={IconLink} />
            <MsgText>
              병원을 연동하면 진료자료, 예약관리, 처방전 등 맟춤형 관리를 받으실 수 있습니다.
            </MsgText>
            <MsgTextBold>
              지금 병원 연동 하시겠습니까?
            </MsgTextBold>

          </MsgContainer>

          <BtnContainer style={{paddingTop:"10px"}}>
            <div style={{padding:"0px 60px", display:"flex"}}>
              <BtnDiv onClick={()=>{
                setCookie("toDayNotAddHspt", "Y", 1);
                closeLayerFn($(".confirm-layer-hsptcnnt"))}
              }>
                아니요
              </BtnDiv>

              <div style={{display:"flex", marginLeft:"auto"}}>
                <img src={IconBtnYes} />
                <BtnDiv onClick={()=>_O.Open("/cnntHspt/1")}>
                  예
                </BtnDiv>
              </div>
            </div>
          </BtnContainer>
        </div>
        
      </div>
    </div>
  )
}

const MsgContainer = styled.div`
  border: 1px solid #707070;
  border-radius: 12px;
  padding: 15px 23px;
  background: #fff;
`;

const MsgText = styled.div`
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-normal) var(--unnamed-font-size-18)/28px var(--unnamed-font-family-pretendard);
  color: var(--unnamed-color-000000);
  text-align: left;
  font: normal normal normal 18px/28px Pretendard;
  letter-spacing: -1.8px;
  color: #000000;
`;

const MsgTextBold = styled.div`
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold) var(--unnamed-font-size-20)/28px var(--unnamed-font-family-pretendard);
  color: var(--unnamed-color-000000);
  text-align: left;
  font: normal normal bold 20px/28px Pretendard;
  letter-spacing: -2px;
  color: #000000;
`;

const BtnContainer = styled.div`
  width: 100%;
`;

const BtnDiv = styled.a`
  // border-bottom: 1px solid #fff;

  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold) 30px/34px Malgun Gothic;
  color: var(--unnamed-color-ffffff);
  text-align: left;
  text-decoration: underline;
  font: normal normal bold 30px/34px Malgun Gothic;
  letter-spacing: -3px;
  color: #FFFFFF;
  opacity: 1;
  line-height: 74px;
`;